/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-NavExample-LeftPane{width:208px;height:500px;-webkit-box-sizing:border-box;box-sizing:border-box;border:1px solid #EEE;overflow-y:auto}\n"}]);